/**
 * Task notes are transported base64-encoded so that rich-text HTML survives the
 * backend round-trip. Decoding is tolerant: legacy plain-text notes are returned
 * unchanged.
 */

const BASE64_PATTERN = /^[A-Za-z0-9+/]+={0,2}$/;

const toBase64 = (value: string): string => {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
};

const fromBase64 = (value: string): string => {
  const binary = atob(value);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

export const encodeTaskNotes = (notes?: string | null): string | undefined => {
  if (notes === null || notes === undefined) return undefined;
  if (notes === '') return '';
  try {
    return toBase64(notes);
  } catch {
    return notes;
  }
};

export const decodeTaskNotes = (notes?: string | null): string | undefined => {
  if (!notes) return undefined;
  const trimmed = notes.trim();
  if (trimmed.length % 4 !== 0 || !BASE64_PATTERN.test(trimmed)) return notes;
  try {
    const decoded = fromBase64(trimmed);
    // Round-trip guards against plain text that happens to look like base64.
    return toBase64(decoded) === trimmed ? decoded : notes;
  } catch {
    return notes;
  }
};
